import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultTo } from 'ramda';
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';
import cn from 'classnames';

import styles from './styles.m.scss';

class AddressSearch extends Component {
  static propTypes = {
    onChangeAddress: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
  };

  state = {
    address: '',
    errorMessage: '',
  };

  handleChange = (address) => {
    const newState = {
      address,
      errorMessage: '',
    };

    this.setState(newState);
  };

  handleSelect = (selected) => {
    this.setState({ address: selected });
    geocodeByAddress(selected)
      .then((res) => this.props.onChangeAddress(res))
      .catch((error) => console.log('error', error));
  };

  handleError = (status, clearSuggestions) => {
    console.log('Error from Google Maps API', status);
    this.setState({ errorMessage: status }, () => {
      clearSuggestions();
    });
  };

  render() {
    const { placeholder } = this.props;
    const { address } = this.state;

    return (
      <div>
        <PlacesAutocomplete
          onChange={this.handleChange}
          value={address}
          onSelect={this.handleSelect}
          onError={this.handleError}
          debounce={300}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps }) => {
            return (
              <div className="form-group">
                <input
                  {...getInputProps({
                    placeholder: defaultTo('Location', placeholder),
                    className: 'form-control',
                  })}
                />
                {suggestions.length > 0 && (
                  <div className={styles.results}>
                    {suggestions.map((suggestion) => (
                      <div
                        {...getSuggestionItemProps(suggestion, {
                          className: cn(styles.item, { [styles.active]: suggestion.active }),
                        })}
                      >
                        <strong>{suggestion.formattedSuggestion.mainText}</strong>{' '}
                        <small>{suggestion.formattedSuggestion.secondaryText}</small>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          }}
        </PlacesAutocomplete>
        <div className="tip">Please click on one of the suggestions to populate all of the address fields</div>
      </div>
    );
  }
}

export default AddressSearch;
